import { useMutation } from '@tanstack/react-query';

import Client from '@/common/utils/client.utility';

export interface PayloadType {
  productVariantId: number;
}
export type CheckBacketFun = (params: PayloadType) => Promise<[]>;

const checkBasket: CheckBacketFun = async (payload: PayloadType) => {
  const client = new Client();

  return await client.post(`/v1/Basket/Shopper/CheckBasket`, payload);
};

export const useCheckBasket = (payload: PayloadType) => {
  return useMutation({
    mutationFn: async () => await checkBasket(payload),
    retry: 1,
  });
};
